import { mapIndicatorDataFrom } from './utils.js';
import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { ThresholdIndicator } from '../../../core/components/threshold-bar/indicators/ThresholdIndicator.js';
import { useGetThresholds } from '../../hooks/useGetThresholds.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import { useHoveredThresholdState } from '../../store/selectors.js';

export const XYChartThresholdIndicators = () => {
  const { thresholds, none } = useGetThresholds();
  const { width } = useGridPlotSize();
  const axisIdToScales = useXYChartScales();
  const hoveredThresholdId = useHoveredThresholdState();

  if (none) {
    return null;
  }

  return (
    <svg className={plotLayout}>
      {thresholds.map((threshold) => {
        const data = mapIndicatorDataFrom({
          axisIdToScales,
          threshold,
          width,
        });

        return (
          <ThresholdIndicator
            key={`threshold-indicator-${threshold.id}`}
            data={data}
            color={threshold.color}
            strokeOnly={threshold.strokeOnly}
            isActive={hoveredThresholdId === threshold.id}
          />
        );
      })}
    </svg>
  );
};
